// typingEffect.js

export function typeQuote(quote, textId, caretId, speed = 100) {
  const textElement = document.getElementById(textId);
  const caretElement = document.getElementById(caretId);

  if (!textElement || !caretElement) return;

  let i = 0;
  textElement.textContent = '';
  caretElement.style.display = 'inline';

  const interval = setInterval(() => {
    if (i < quote.length) {
      textElement.textContent += quote.charAt(i);
      i++;
    } else {
      clearInterval(interval);
      caretElement.style.display = 'none';
    }
  }, speed);
}
